import { queries } from 'RestAPIs/rapini';
import { isValid } from 'date-fns';
import type { HoursPayOutRequestResponse } from 'generated/index';
import type { HoursPayOutRequestRow } from '../HoursPayOutRequestsOverview.types';
import { useState } from 'react';
import type { UseDateRangeCalculationOutput } from './useDateRangeCalculation';

interface UseHoursPayOutDataInput {
  dateRange: UseDateRangeCalculationOutput;
  organizationalUnitIds: string;
}

export const useHoursPayOutData = ({
  dateRange,
  organizationalUnitIds
}: UseHoursPayOutDataInput) => {
  'use memo';

  const [onlyToApprove, setOnlyToApprove] = useState(true);

  const {
    data = [],
    isLoading,
    isError,
    refetch
  } = queries.useFindHoursPayOutRequestsByOrganizationalUnits(
    dateRange.startDate,
    dateRange.endDate,
    // @ts-ignore no paramsSerializer is configured on axios, so the ids have to
    // be sent as a comma separated string instead of an array
    organizationalUnitIds as string[],
    onlyToApprove,
    {
      enabled:
        !!organizationalUnitIds &&
        !!dateRange.startDateValue &&
        !!dateRange.endDateValue &&
        isValid(dateRange.startDateValue) &&
        isValid(dateRange.endDateValue) &&
        (!dateRange.isCustomRange || dateRange.hasCompleteCustomRange)
    }
  );

  const rows: HoursPayOutRequestRow[] = data.map(
    (request: HoursPayOutRequestResponse) => ({
      ...request,
      remainingInMinutes: request.currentBalanceInMinutes ?? null,
      // only a request that is still awaiting processing can be paid out or rejected
      disableSelection: request.status !== 'SUBMITTED'
    })
  );

  return {
    rows,
    isLoading,
    isError,
    refetch,
    onlyToApprove,
    setOnlyToApprove
  };
};
